{
    "Profile_Dwellings_WaterMitigationSystem.waterMitigationSystem": "FR: Water Mitigation System",
    "Profile_Dwellings_WaterMitigationSystem.waterMitigationDetails": "FR: Water Mitigation Details",
    "Profile_Dwellings_WaterMitigationSystem.sumpPumpType": "FR: Sump Pump Type",
    "Profile_Dwellings_WaterMitigationSystem.backupValveType": "FR: Backup Valve Type",
    "Profile_Dwellings_WaterMitigationSystem.auxiliaryPower": "FR: Auxiliary Power",
    "Profile_Dwellings_WaterMitigationSystem.connectedToAlarm": "FR: Connected To Alarm",
    "Profile_Dwellings_WaterMitigationSystem.primary": "FR: Primary"
}
